
import React, { FC, Ref } from 'react';
import { selectTournament } from '../../../../../features/tournament/tournamentSelectors';

import { useAppSelector } from '../../../../../hooks/redux';
import { IMatch } from '../PlayTag/PlayTag';
import { TournamentPrintCardTeam } from '../TournamentPrintCardTeam';
import { getSideDisplayNames } from './TournamentPrintCard.helpers';
import { TournamentCardHeadSection } from '../TournamentCardHeadSection';

import './TournamentPrintCard.scss';

interface TournamentPrintCardProps {
    ref: Ref<any>;
    matches: IMatch[];
}

export const TournamentPrintCard: FC<TournamentPrintCardProps> = React.forwardRef(({ matches }, ref) => {
    const { courts } = useAppSelector(selectTournament).data || {};

    return (<div ref={ref} className="tournament-print-card">
        {matches.map((match, index) => {
            const { name: courtName } = courts?.find(({ id }) => id === match.court) || { name: '' };
            const home = getSideDisplayNames(match, 'home');
            const away = getSideDisplayNames(match, 'away');
            return (
                <div key={match.id} className={"tournament-print-card__match" + ((index % 2 === 1 || index === matches.length - 1) ? ' tournament-print-card__match_last' : '')}>
                    <TournamentCardHeadSection
                        matchId={match.matchId}
                        court={courtName}
                        startDate={match.startDate}
                        scheduleDate={match.scheduleDate}
                    />
                    <div className="tournament-print-card__home-team">
                        <TournamentPrintCardTeam
                            matchId={match.matchId}
                            court={courtName}
                            team={1}
                            player1={home.player1}
                            player2={home.player2}
                        />
                    </div>
                    <div className="tournament-print-card__away-team">
                        <TournamentPrintCardTeam
                            matchId={match.matchId}
                            court={courtName}
                            team={2}
                            player1={away.player1}
                            player2={away.player2}
                        />
                    </div>
                </div>
            )
        })}
    </div>)
});